export default "__VITE_ASSET__B8GX2DoM__"